import React from "react";
import { Panel, TextBox, Tree, Button, showSnackbar } from "lib/components";
import { useState } from "react";
import { useMountEffect } from "core/hooks";
import { fetch } from "lib/util/fetch";
import { buildAPIUrl } from "core/utils/urls";

export function OpenFileDropDown({fileSelected}) {
  const [data, setData] = useState();
  const [searchText, setSearchText] = useState();
  const [selectedPath, setSelectedPath] = useState();
  useMountEffect(() => {
    loadData(fileSelected, setData);
  })
  return (
    <Panel height={500} width={300} padding={24}>
      <TextBox caption="Search" fillRow value={searchText} onChange={setSearchText}/>
      <Tree nodes={data} marginTop={12} fillRow  height={332} onNodeSelect={(event, nodeId) => setSelectedPath(nodeId)}/>
      <Panel fillRow>
        <Panel fillRow noRowBreak/>
        <Button color="primary" caption="OK" onClick={() => fileSelected(selectedPath) }/>
      </Panel>
    </Panel>
  );
}

// This api method is commented out in LayoutController
async function loadData(fileSelected, setData) {
  await fetch({url: buildAPIUrl("layout/list")}).then((response) => {
    let data = createTreeData(response.data, fileSelected);
    setData(data);
  }).catch((reason) => {
    showSnackbar("Error loading list of layouts - " + reason);
  })
}

function createTreeData(array, fileSelected) {
  let result = [];
  let lastPath = null;
  for (let i = 0; i < array.length; i++) {
    let path = array[i].split("/");
    if (path[0] !== lastPath)
      result.push({key: "branch-" + path, caption: path[0], nodes:[]});
    result[result.length - 1].nodes.push(
      {
        caption: path[1],
        key: array[i]
      }
    );
    lastPath = path[0];
  }
  return result;
}
